import React from 'react';
import { Router, Switch, Route } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import Layout from '../components/layout/Layout';
import authService from '../services/api/auth';
import PrintPage from '../components/printQueue/printPage';
import { localhostname } from '../components/helpers';

import Academy from '../pages/academy/academy';
import Home from '../pages/Home';
import Admin from '../pages/admin/Admin';
import NewMembersForm from '../pages/experience/conexion/newMembersForm';
import ServiceReservation from '../pages/events/reservation';
import GroupReservation from '../pages/groups/groupsRegistration';
import LeadersAdminGroup from '../pages/groups/leadersView';
import GroupCompliance from '../pages/groups/groupCompliance';
import ParentGeneracionesMatch from '../pages/generaciones/parentGeneracionesMatch';
import { SendCheckoutInfo } from '../pages/payments/checkout';
import TransactionResponse from '../pages/payments/transactionResponse';
import ParentsReserve from '../pages/generaciones/parentsReserve';
import VolunteersLogs from '../pages/experience/volunteers/volunteersLogs';
import ConfirmedVolunteersCheck from '../pages/experience/volunteers/VolunteersChecks';
import ProspectLeadersForm from '../pages/groups/prospectLeadersForm';
import DiezmosYOfrendas from '../pages/payments/diezmosYOfrendas';
import NewLeadersForm from '../pages/groups/newLeadersForm';
import NewLeaderLeaderView from '../pages/groups/newLeaderLeaderView';
import WeddingRequest from 'src/pages/wedding-requests/weddingRequest';
import GuestDashboard from 'src/pages/guests/GuestDashboard';
import Error404 from '../pages/Error404';
import Login from '../pages/auth/Login';
import ResetPassword from '../pages/auth/ResetPassword';
import Registration from '../pages/admin/Registration';
import BlankLoader from '../pages/BlankLoader';
import CheckInRedirect from '../pages/CheckIn';
import CrecerCheckIn from '../pages/checkin/CrecerCheckIn';
import ServiceCheckIn from '../pages/checkin/ServiceCheckIn';
import PrintQueueTable from '../pages/PrintTable';
import AdminDashboard from '../pages/admin/AdminDashboard';
import Survey from '../pages/crecer/surveys/survey';
import RedComunidadEmpresa from '../pages/comunidad-network/RedComunidadEmpresa';
import ComunidadNetworkCatalog from '../pages/comunidad-network/RedEmpresasCatalog';
import CrecerSelfAttendance from '../pages/crecer/crecerSelfAttendance';
import CrecerAutoAsistencia from '../pages/crecer/CrecerAutoAsistencia';
import CounselingForm from '../pages/counselingForm';
import EventCertificate from '../pages/events/eventCertificate';
import NewVolunteersForm from '../pages/experience/volunteers/newVolunteersForm';

import WeddingRequestFacilitators from 'src/pages/wedding-requests/weddingRequestFacilitators';
import LegadoLanding from 'src/pages/payments/legado/LegadoLanding';
import AcademyAdminDashboard from 'src/containers/academy/admin/AcademyAdminDashboard';
import RelationsForm from 'src/pages/crecer/RelationsForm';
import LegadoPostDonationTotalChurch from 'src/pages/payments/legado/LegadoPostDonationTotalChurch';
import QRCodeGenerator from 'src/pages/utils/qrCodeGen';
import WhatsAppTemplateTest from 'src/pages/utils/WhatsAppTemplateTest';
import IntranetHome from 'src/pages/intranet/home';
import PublicRoutesMap from 'src/pages/PublicRoutesMap';

export function PrivateRoute({ component: Component, ...rest }) {
  if (localStorage.getItem('userToken')) {
    return (
      <Route
        {...rest}
        render={(props) => (
          <Layout {...rest}>
            <Component {...props} />
          </Layout>
        )}
      />
    );
  } else {
    return authService.logout();
  }
}
export function RouteLayout({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => (
        <Layout {...rest}>
          <Component {...props} />
        </Layout>
      )}
    />
  );
}

const App = () => {
  const loc = window.location;
  const protocol = process.env.REACT_APP_PROTOCOL || 'https';
  const hostname = process.env.REACT_APP_HOSTNAME || localhostname;

  const history = createBrowserHistory();

  React.useEffect(() => {
    window.sessionStorage.removeItem('times');
    if (loc.hostname === hostname) {
      if (loc.protocol !== `${protocol}:`) {
        loc.replace(`${protocol}:${loc.href.substring(loc.protocol.length)}`);
      }
    }
    if (loc.hostname !== hostname) {
      loc.replace(`${protocol}://${hostname}${loc.pathname}${loc.search}`);
    }
  }, []);

  if (loc.hostname === hostname && loc.protocol === `${protocol}:`) {
    return (
      <Router history={history}>
        <Switch>
          <Route exact path="/checkin/print" component={PrintPage} />
          <Route exact path="/payucheckout" component={SendCheckoutInfo} />
          <Route exact path="/logout" component={Login} />
          <RouteLayout exact path="/" component={Home} />
          <RouteLayout exact path="/login" component={Login} />
          <RouteLayout exact path="/respuesta-transaccion" component={TransactionResponse} />
          <RouteLayout exact path="/diezmosyofrendas" component={DiezmosYOfrendas} />
          <PrivateRoute exact path="/registration" component={Registration} />
          <PrivateRoute exact path="/mapa-rutas" component={PublicRoutesMap} />

          {/* Legado */}
          <RouteLayout exact path="/legado" component={LegadoLanding} />
          <RouteLayout
            exact
            path="/legado-total-iglesia"
            component={LegadoPostDonationTotalChurch}
          />
          <Route
            exact
            path="/legado-total-iglesia-landing"
            component={LegadoPostDonationTotalChurch}
          />

          {/* Grupos */}
          <RouteLayout exact path="/grupos/acuerdo/:doc" component={GroupCompliance} />
          <RouteLayout exact path="/grupos/registrarse" component={GroupReservation} />
          <RouteLayout exact path="/grupos/lider" component={LeadersAdminGroup} />
          <RouteLayout exact path="/grupos/encuesta/:hexaCode?" component={ProspectLeadersForm} />
          <RouteLayout
            exact
            path="/grupos/aspirante/:leaderToken"
            component={NewLeaderLeaderView}
          />
          <RouteLayout exact path="/grupos/aspirante" component={NewLeadersForm} />

          {/* Solicitud de matrimonio */}
          <RouteLayout exact path="/solicitud-matrimonio" component={WeddingRequest} />
          <RouteLayout
            exact
            path="/solicitudes-matrimonio"
            component={WeddingRequestFacilitators}
          />

          {/* Experiencia */}
          <RouteLayout exact path="/experiencia/voluntarios" component={VolunteersLogs} />
          <RouteLayout exact path="/nuevo-voluntario" component={NewVolunteersForm} />
          <PrivateRoute path="/voluntarios-servicio" component={ConfirmedVolunteersCheck} />

          {/* Conexion */}
          <RouteLayout exact path="/bienvenido" component={NewMembersForm} />

          {/* Social */}
          <RouteLayout exact path="/inscripcion-red-empresas" component={RedComunidadEmpresa} />
          <RouteLayout exact path="/catalogo-red-empresas" component={ComunidadNetworkCatalog} />
          <RouteLayout exact path="/consejeria" component={CounselingForm} />

          {/* Crecer */}
          <RouteLayout exact path="/crecer/encuestas" component={Survey} />
          <RouteLayout exact path="/crecer/registrarse/:seminary" component={GroupReservation} />
          <RouteLayout exact path="/crecer/autoregistro" component={CrecerSelfAttendance} />
          <RouteLayout exact path="/crecer/autoasistencia" component={CrecerAutoAsistencia} />
          <RouteLayout exact path="/crecer/seminario-relaciones-sanas" component={RelationsForm} />

          {/* Crecer Plus */}
          <RouteLayout exact path="/crecerplus/:courseId" component={Academy} />
          <RouteLayout exact path="/crecerplus" component={Academy} />
          <RouteLayout exact path="/admin/crecerplus" component={AcademyAdminDashboard} />

          {/* Reservaciones */}
          <RouteLayout exact path="/servicio/reservacion" component={ServiceReservation} />
          <PrivateRoute exact path="/checkin/print-queue" component={PrintQueueTable} />
          <PrivateRoute exact path="/checkin/crecer" component={CrecerCheckIn} />
          <PrivateRoute exact path="/checkin/servicio" component={ServiceCheckIn} />
          <PrivateRoute exact path="/checkin" component={CheckInRedirect} />

          {/* Generaciones */}
          <RouteLayout exact path="/servicio/reservacion/generaciones" component={ParentsReserve} />
          <PrivateRoute exact path="/servicio/generaciones" component={ParentGeneracionesMatch} />

          {/* Certificados */}
          <RouteLayout exact path="/certificado/evento" component={EventCertificate} />

          {/* Utilidades */}
          <RouteLayout exact path="/utils/generador-qr" component={QRCodeGenerator} />
          <RouteLayout exact path="/utils/qr" component={QRCodeGenerator} />
          <PrivateRoute exact path="/utils/whatsapp-test" component={WhatsAppTemplateTest} />

          {/* Admin */}
          <PrivateRoute exact path="/admin/*" component={Admin} />
          <Route exact path="/users/reset-password/:token" component={ResetPassword} />

          {/* Guest Dashboard */}
          <RouteLayout exact path="/perfil/*" component={GuestDashboard} />

          {/* Admin Dashboard */}
          <PrivateRoute exact path="/tablero/*" component={AdminDashboard} />

          {/* Intranet Dashboard */}
          <Route exact path="/intranet/*" component={IntranetHome} />

          {/* Error */}
          <RouteLayout component={Error404} />
        </Switch>
      </Router>
    );
  }
  return <BlankLoader />;
};

export default App;
